import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IPart, IPartCategory } from "../../../models/Part";
import PriceFormat from "../../../utils/priceFormat";

interface RsPriceButtonProps {
  category?: IPartCategory;
  part?: IPart;
  onPriceSelect: (price: number) => void;
}

export default function RsPriceButton({
  category, part, onPriceSelect
}: RsPriceButtonProps) {
  const { t } = useTranslation("common");

  if (category?.rsPrice == null) return (<></>);

  return (
    <button
      title={t("RS Automotive Price")}
      onClick={() => onPriceSelect(category?.rsPrice ?? 0)}
      className="border text-white shadow rounded-md p-1 px-2 bg-[#69141E] w-20 text-center hover:bg-[#4a0f14] hover:text-white"
      type="button"
    >
      <span className="font-bold">{PriceFormat(category.rsPrice)}</span>
    </button>
  );
}